import React from "react";
import { elementType, node } from "prop-types";
import Button from "../Button";
import Paragraph from "../Paragraph";

const CardBlockAction = ({ ActionComponent = Button, children, ...props }) => (
	<Paragraph sx={{ textAlign: "center" }} spacing={{ mt: 20 }}>
		<ActionComponent.Link styleType="primary" isOutline size="xs" {...props}>
			{children}
		</ActionComponent.Link>
	</Paragraph>
);

CardBlockAction.propTypes = {
	ActionComponent: elementType,
	children: node.isRequired,
};

export default CardBlockAction;
